import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

interface IFormActionsProps {
    cancelText?: string;
    cancelUrl: string;
    pullRight?: boolean;
    hideSave?: boolean;
    saveButtonText?: string;
    processingText?: string;
    savingText?: string;
    saving?: boolean;
    handleSave?: () => Promise<void>;
}

const FormActions: React.FC<IFormActionsProps> = ({
    cancelText,
    cancelUrl,
    hideSave,
    pullRight,
    saveButtonText,
    processingText,
    savingText,
    saving,
    handleSave,
}) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <hr />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <div className={pullRight ? 'pull-right' : ''}>
                                <>
                                    <>
                                        <span style={{ marginRight: '10px' }}>
                                            {processingText}
                                        </span>
                                    </>
                                    {!hideSave && (
                                        <button
                                            name="saveButton"
                                            aria-label="save"
                                            type={
                                                handleSave ? 'submit' : 'button'
                                            }
                                            className="btn btn-primary"
                                            onClick={handleSave}
                                        >
                                            <>
                                                {saving ? (
                                                    <>
                                                        {!savingText ? (
                                                            <FormattedMessage id="Saving" />
                                                        ) : (
                                                            <>{savingText}</>
                                                        )}
                                                        {' ...'}
                                                    </>
                                                ) : (
                                                    <>
                                                        {!saveButtonText ? (
                                                            <FormattedMessage id="Submit" />
                                                        ) : (
                                                            <>
                                                                {saveButtonText}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        </button>
                                    )}
                                </>
                                <Link
                                    role="button"
                                    className="btn btn-default"
                                    to={cancelUrl}
                                >
                                    <>
                                        {!cancelText ? (
                                            <FormattedMessage id="Cancel" />
                                        ) : (
                                            <>{cancelText}</>
                                        )}
                                    </>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FormActions;
